module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-medium-webfont.5f0dd9f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-medium-webfont.svg
// module id = 378
// module chunks = 3